/**
 * Detects the current text format based on editor state
 * @param {Editor} editor - The TipTap editor instance
 * @returns {string} - The current format (normal, h1, h2, h3, superscript, subscript)
 */
export const detectCurrentFormat = (editor) => {
	if (!editor) return "normal";
	
	if (editor.isActive("heading", { level: 1 })) {
		return "h1";
	} else if (editor.isActive("heading", { level: 2 })) {
		return "h2";
	} else if (editor.isActive("heading", { level: 3 })) {
		return "h3";
	} else if (editor.isActive("superscript")) {
		return "superscript";
	} else if (editor.isActive("subscript")) {
		return "subscript";
	} else {
		return "normal";
	}
};

/**
 * Applies the selected text format to the editor
 * @param {Editor} editor - The TipTap editor instance
 * @param {string} format - The format to apply
 * @param {Function} setCurrentFormat - State setter for current format
 */
export const applyTextFormat = (editor, format, setCurrentFormat) => {
	if (!editor) return;
	
	editor.chain().focus();
	
	// Reset all formatting first
	if (editor.isActive("heading")) {
		editor.chain().focus().setParagraph().run();
	}
	if (editor.isActive("superscript")) {
		editor.chain().focus().toggleSuperscript().run();
	}
	if (editor.isActive("subscript")) {
		editor.chain().focus().toggleSubscript().run();
	}

	// Apply the selected format
	switch (format) {
		case "h1":
			editor.chain().focus().setHeading({ level: 1 }).run();
			setCurrentFormat("h1");
			break;
		case "h2": 
			editor.chain().focus().setHeading({ level: 2 }).run();
			setCurrentFormat("h2");
			break;
		case "h3": 
			editor.chain().focus().setHeading({ level: 3 }).run();
			setCurrentFormat("h3");
			break;
		case "superscript":
			editor.chain().focus().toggleSuperscript().run();
			setCurrentFormat("superscript");
			break;
		case "subscript":
			editor.chain().focus().toggleSubscript().run();
			setCurrentFormat("subscript");
			break;
		default:
			editor.chain().focus().setParagraph().run();
			setCurrentFormat("normal");
			break;
	}
};